import React, { Component } from 'react';
import { connect } from "react-redux";
import cookie from 'react-cookies';
import ReloadConfigPrompt from './reload_config_prompt';

class ReloadConfigPromptWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfigRelaodPrompt: true,
            ignoreConfigRelaodPrompt: false,
        }
    }

    ignorePrompt = () => {
        this.setState({ignoreConfigRelaodPrompt: true})
    }

    closePrompt = (resetIgnoreFlag) => {
        this.setState({showConfigRelaodPrompt: false})
        
        if(resetIgnoreFlag) {
            this.setState({ignoreConfigRelaodPrompt: false})
        }
    }

    componentDidUpdate() {
        if(cookie.loadAll().superuser === "true" && 
            this.props.device &&
            this.props.device.scanner_health &&
            this.props.device.scanner_health.scanner_response &&
            this.props.device.scanner_health.scanner_response.usingStaleConfig &&
            !this.state.ignoreConfigRelaodPrompt && !this.state.showConfigRelaodPrompt)
            this.setState({showConfigRelaodPrompt: true})
    }

    render() {
        let isConfigReloadPromptNeeded = (
            cookie.loadAll().superuser === "true" && 
            this.props.device &&
            this.props.device.scanner_health &&
            this.props.device.scanner_health.scanner_response &&
            this.props.device.scanner_health.scanner_response.usingStaleConfig &&
            this.state.showConfigRelaodPrompt);
                    
        return(
            <div className="relative-position">
                <div className={isConfigReloadPromptNeeded ? "blur" : ""}>    
                    {this.props.children}
                </div>
                {isConfigReloadPromptNeeded ? 
                    <ReloadConfigPrompt device={{...this.props.device, id: this.props.deviceId}} closePromptHook={this.closePrompt} ignorePromptHook={this.ignorePrompt}/>
                    :
                    null
                }
            </div>
        )     
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        device: state.deviceStatusReducer[ownProps.deviceId],
    };
};

export default connect(mapStateToProps)(ReloadConfigPromptWrapper);

